var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightChevronCarosuel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.68768 0.216C5.83168 0.072 6.00768 0 6.21568 0C6.42368 0 6.59968 0.072 6.74368 0.216L18.5277 12L6.74368 23.784C6.59968 23.928 6.42368 24 6.21568 24C6.00768 24 5.83168 23.928 5.68768 23.784C5.54368 23.64 5.47168 23.464 5.47168 23.256C5.47168 23.048 5.54368 22.872 5.68768 22.728L16.4157 12L5.68768 1.272C5.54368 1.128 5.47168 0.951999 5.47168 0.743999C5.47168 0.536 5.54368 0.36 5.68768 0.216Z",
    fill: "#415385"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightChevronCarosuel);
export default __webpack_public_path__ + "static/media/right-chevron-carosuel.ebb2f0852bb7a5399802f9f1e0d8edb5.svg";
export { ForwardRef as ReactComponent };